// Flowbite owns positioning, rendering and the instances; this adds touch dismissal.
(() => {
    if (window.clasicoCompactTooltipsReady) return;
    window.clasicoCompactTooltipsReady = true;
    let currentId = null;
    const instance = id => id ? window.FlowbiteInstances?.getInstance('Tooltip', id) : null;
    const hide = () => { instance(currentId)?.hide(); currentId = null; };
    document.addEventListener('click', event => {
        const disclosure = event.target.closest('[data-compact-expand]');
        if (disclosure) {
            const panel = document.getElementById(disclosure.dataset.compactExpand);
            if (panel) {
                panel.hidden = !panel.hidden;
                disclosure.setAttribute('aria-expanded', String(!panel.hidden));
            }
        }
        const trigger = event.target.closest('[data-tooltip-target]');
        const id = trigger?.dataset.tooltipTarget;
        if (id && document.getElementById(id)?.matches('[data-compact-tooltip]')) {
            if (currentId && currentId !== id) hide();
            instance(id)?.show();
            currentId = id;
        } else if (!event.target.closest('[data-compact-tooltip]')) hide();
    });
    document.addEventListener('focusin', event => {
        const id = event.target.closest('[data-tooltip-target]')?.dataset.tooltipTarget;
        if (currentId && currentId !== id) hide();
        if (id && document.getElementById(id)?.matches('[data-compact-tooltip]')) currentId = id;
    });
    document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        hide();
        document.querySelectorAll('[data-compact-tooltip]').forEach(el => instance(el.id)?.hide());
    });
    new MutationObserver(records => {
        for (const record of records) for (const node of record.removedNodes) {
            if (!(node instanceof Element)) continue;
            const targets = node.matches('[data-compact-tooltip]') ? [node] : node.querySelectorAll('[data-compact-tooltip]');
            for (const target of targets) {
                if (!document.getElementById(target.id)) instance(target.id)?.destroyAndRemoveInstance();
            }
        }
    }).observe(document.body, {childList: true, subtree: true});
})();
